import { useContext, useEffect } from 'react';
import { Box, Grid } from '@mui/material'
import MainLayout from '../components/common/layout/MainLayout'
import ProfileLeftNavigation from '../components/profile/navigation/profileLeftNavigation';
import AccountDetails from '../components/profile/acctDetails';
import SystemInfo from '../components/profile/systemInfo';
import HelpAndSupport from '../components/profile/helpAndSupport';
import ProfileMobileNavigation from '../components/profile/navigation/profileMobileNavigation';
import { DataContext, DataDispatchContext } from '../contexts/data/dataContext'
import custom from '../styles/mui/szVariables.json'
import { clickAnalyticsProfile } from '../components/common/util/util'

export default function Profile() {
  const data = useContext(DataContext)
  const dispatch: any = useContext(DataDispatchContext)
  
  useEffect(() => {
    window.scrollTo(0,0)
    if(data?.rightPanel?.key!=='help') {
      dispatch({
        type: 'setRightPanel',
        rightPanel: null
      })
    }
  },[dispatch,data?.rightPanel])

  return (
    <MainLayout>
      <Box display="flex" 
            flexDirection="row" 
            id="accountContent"
            justifyContent="flex-start"
            maxWidth={"100%"}
          >
          <Grid container direction={"column"} 
              justifyContent={"center"}>
              <Grid item maxWidth="100%" 
                borderBottom={custom.border}
                display={{ 
                  xs: 'flex', 
                  sm: data.rightPanel?'flex':'none', 
                  md: 'none', 
                  lg: 'none'
                }}
                >
                <ProfileMobileNavigation
                    clickAnalytics={clickAnalyticsProfile} 
                    acctSelected={data?.acctSelected}/>
              </Grid>
              <Grid item maxWidth="100%" >
                <Grid container direction="row" 
                    justifyContent={"center"} 
                    maxWidth="100%">
                  <Grid item width={{
                        xs: 0,
                        sm: "234px",
                        md: "234px",
                        lg: "234px",
                      }}
                      display={{ 
                        xs: 'none', 
                        sm: data.rightPanel?'none':'flex', 
                        md: 'flex', 
                        lg: 'flex'
                      }}>
                      <ProfileLeftNavigation 
                          clickAnalytics={clickAnalyticsProfile} 
                          acctSelected={data?.acctSelected}/>
                  </Grid>         
                  <Grid item xs>
                    {data?.acctSelected==='details' &&
                      <Box sx={{ display: 'flex' }}>
                        <AccountDetails />
                      </Box>
                    }
                    {data?.acctSelected==='system' && 
                      <Box sx={{ display: 'flex'}}>
                        <SystemInfo />
                      </Box>
                    }
                    {data?.acctSelected==='help' && 
                      <Box sx={{ display: 'flex' }}>
                        <HelpAndSupport />
                      </Box>
                    }
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
      </Box>
    </MainLayout>
  )
}
